export default __webpack_public_path__ + "static/media/img2.fcc283d6.PNG";